export default {"src":"/_next/static/media/allr-icon.204d0c70.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};